import { createStyles } from 'uinix-ui';

import { BREAKPOINT_VALUES } from './breakpoints';
import { globalStyles as global } from './global';
import { animations } from './rules/animations';
import { background } from './rules/background';
import { borderRadius } from './rules/borderRadius';
import { button } from './rules/button';
import { colors } from './rules/colors';
import { disabled } from './rules/disabled';
import { disabledVisual } from './rules/disabledVisual';
import { focus } from './rules/focus';
import { font } from './rules/font';
import { gridColumns } from './rules/gridColumns';
import { gridItem } from './rules/gridItem';
import { hidden } from './rules/hidden';
import { highlight } from './rules/highlight';
import { input } from './rules/input';
import { interactable } from './rules/interactable';
import { interactions } from './rules/interactions';
import { interactionsInverse } from './rules/interactionsInverse';
import { link } from './rules/link';
import { list } from './rules/list';
import { menu } from './rules/menu';
import { pill } from './rules/pill';
import { position } from './rules/position';
import { readOnly } from './rules/readOnly';
import { scroll } from './rules/scroll';
import { shimmer } from './rules/shimmer';
import { size } from './rules/size';
import { sticky } from './rules/sticky';
import { tabs } from './rules/tabs';
import { truncate } from './rules/truncate';
import { truncateLines } from './rules/truncateLines';
import { typography } from './typography';
import { variants } from './variants';

export const styles = createStyles({
  animations,
  background,
  borderRadius,
  button,
  colors,
  disabled,
  disabledVisual,
  focus,
  font,
  gridColumns,
  gridItem,
  hidden,
  highlight,
  input,
  interactable,
  interactions,
  interactionsInverse,
  link,
  list,
  menu,
  pill,
  position,
  readOnly,
  scroll,
  shimmer,
  size,
  sticky,
  tabs,
  truncate,
  truncateLines,
  breakpoints: BREAKPOINT_VALUES,
  global,
  typography,
  variants,
});
